import { render, staticRenderFns } from "./assembly.vue?vue&type=template&id=b82c5b8a&scoped=true"
import script from "./assembly.vue?vue&type=script&lang=js"
export * from "./assembly.vue?vue&type=script&lang=js"
import style0 from "./assembly.vue?vue&type=style&index=0&id=b82c5b8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c5b8a",
  null
  
)

export default component.exports